// Create types
export const INVOICE_CREATE_ERROR = 'INVOICE_CREATE_ERROR';
export const INVOICE_CREATE_LOADING = 'INVOICE_CREATE_LOADING';
export const INVOICE_CREATE_SUCCESS = 'INVOICE_CREATE_SUCCESS';
export const INVOICE_CREATE_VIOLATIONS = 'INVOICE_CREATE_VIOLATIONS';
export const INVOICE_CREATE_RESET = 'INVOICE_CREATE_RESET';

// Show types
export const INVOICE_SHOW_ERROR = 'INVOICE_SHOW_ERROR';
export const INVOICE_SHOW_LOADING = 'INVOICE_SHOW_LOADING';
export const INVOICE_SHOW_RETRIEVED_SUCCESS = 'INVOICE_SHOW_RETRIEVED_SUCCESS';
export const INVOICE_SHOW_RESET = 'INVOICE_SHOW_RESET';

// Update types
export const INVOICE_UPDATE_RESET = 'INVOICE_UPDATE_RESET';
export const INVOICE_UPDATE_UPDATE_ERROR = 'INVOICE_UPDATE_UPDATE_ERROR';
export const INVOICE_UPDATE_UPDATE_LOADING = 'INVOICE_UPDATE_UPDATE_LOADING';
export const INVOICE_UPDATE_UPDATE_SUCCESS = 'INVOICE_UPDATE_UPDATE_SUCCESS';
export const INVOICE_UPDATE_RETRIEVE_ERROR = 'INVOICE_UPDATE_RETRIEVE_ERROR';
export const INVOICE_UPDATE_RETRIEVE_LOADING = 'INVOICE_UPDATE_RETRIEVE_LOADING';
export const INVOICE_UPDATE_RETRIEVE_SUCCESS = 'INVOICE_UPDATE_RETRIEVE_SUCCESS';
export const INVOICE_UPDATE_UPDATE_VIOLATIONS = 'INVOICE_UPDATE_UPDATE_VIOLATIONS';

// Update types
export const INVOICE_CORRECTION_RESET = 'INVOICE_CORRECTION_RESET';
export const INVOICE_CORRECTION_RETRIEVE_ERROR = 'INVOICE_CORRECTION_RETRIEVE_ERROR';
export const INVOICE_CORRECTION_RETRIEVE_LOADING = 'INVOICE_CORRECTION_RETRIEVE_LOADING';
export const INVOICE_CORRECTION_RETRIEVE_SUCCESS = 'INVOICE_CORRECTION_RETRIEVE_SUCCESS';

// Delete types
export const INVOICE_DELETE_ERROR = 'INVOICE_DELETE_ERROR';
export const INVOICE_DELETE_LOADING = 'INVOICE_DELETE_LOADING';
export const INVOICE_DELETE_SUCCESS = 'INVOICE_DELETE_SUCCESS';
export const INVOICE_DELETE_RESET = 'INVOICE_DELETE_RESET';

// List types
export const INVOICE_LIST_ERROR = 'INVOICE_LIST_ERROR';
export const INVOICE_LIST_LOADING = 'INVOICE_LIST_LOADING';
export const INVOICE_LIST_RESET = 'INVOICE_LIST_RESET';
export const INVOICE_LIST_PAGINATION = 'INVOICE_LIST_PAGINATION';
export const INVOICE_LIST_SUCCESS = 'INVOICE_LIST_SUCCESS';
export const INVOICE_LIST_ORDER = 'INVOICE_LIST_ORDER';
export const INVOICE_LIST_PAGE = 'INVOICE_LIST_PAGE';



// WEBPACK FOOTER //
// ./src/store/modules/invoice/mutation-types.js